module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEtSURBVFiF7ZjBbcJAEEXfRBSQEtyJt4SUACWkgpgKoANcAh0EOqED6GByiLEMLEj2H0c57Dsha/X0vQv4j3H3ncexIxhzdw8VmlmkbzH4fACOEz01kNQwWQbH0wiO5ioJjAbc7mAo7p6Ab1GzfwvI8owU4PiYbQfvWI9c33+n/ySgmTVj1ne/hwQw5xGHUAKqlIAqJaBKCagyfJLUQqOpA7JkGQZMzNXpBBZACyyDfG3u4hw9UcbdlwEzzjl0fsiFBCpB0T7Ura4JJ0F6MbOtu78LjivVww66+xlQ5avOsRE9p1xhDbnzAAdA9eqPem0jeSaa4OlHhH//JCkBVUpAlRJQpQRUKQFVXr3dUmaUGyZ4+hknV7ci6vknv63oSxXljvggOk+dYw9cRFf7A1Qr7L36519hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_home.png
// module id = Ye28
// module chunks = 3